import { tenantIDAtom } from "atoms/GlobalAtoms";
import { useAtomValue } from "jotai";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";

const FieldSettingsButton = ({ module }) => {
  const navigate = useNavigate();
  const tenantID = useAtomValue(tenantIDAtom);

  return (
    <Button
      size="sm"
      color="primary"
      className="mt-3 d-flex align-items-center"
      onClick={goToFieldSettings}
    >
      Go To Field Settings{" "}
      <i
        className="mdi mdi-arrow-right-bold ml-2 mr-1"
        style={{ fontSize: 16 }}
      />
    </Button>
  );

  function goToFieldSettings() {
    navigate(
      `/clouds/${tenantID}/settings/modules/manage/${module?.APIName}/fields`
    );
  }
};

export default FieldSettingsButton;
